import { styled } from "styled-components";

export const BigAvatarDetails = styled.div`
  color: var(--clr-black);
  font-size: 14px;
  font-style: normal;
  font-weight: var(--fw-semi-bold);
  line-height: normal;
`;
